var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowGray17 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M10 8.535H0v1h10z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C4C4C4",
  d: "M6.464 12.571 10 9.036 6.464 5.5"
})));
export default SvgIconArrowGray17;